import validations from "./employerNumber";
const validator = {
  getMessage() {
    // will be added to default English messages.
    return "Invalid CPF";
  },
  validate(value) {
    if (value.length > 14) {
      return validations.cnpjValidate(value);
    } else {
      return validations.cpfValidate(value);
    }
  }
};
export default validator;
